<template>
  <div id="app">
    <keep-alive >
      <router-view v-if="$route.meta.keepalive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepalive"/>
    <div class="jishuzhichi" v-if="$route.meta.jishuzhichi">
        <div>万维云招标采购信息平台</div>
        <div @click="goBeian">鲁ICP备2023018119号</div>
        <div>技术支持：<span>临朐万维腾景数字技术有限公司</span></div>
    </div>
  </div>
</template>
<script>
import {mapMutations} from 'vuex'
export default {
  created(){
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
    this.UPDATE_TOKEN(token)
  },
  methods:{
    ...mapMutations([
        'UPDATE_TOKEN'
      ]),
    goBeian(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index','_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
  .jishuzhichi{
    padding: 20px 0;
    background-color: #f7f7f7;
    text-align: center;
    div{
        margin-bottom: 5px;
    }
    div:nth-child(2){
        cursor: pointer;
        &:hover{
            color: orange;
        }
    }
    span{
        cursor: pointer;
        &:hover{
            color: orange;
        }
    }
  }
</style>
